import axios from "../../../util/axios";
export default {
    // 查询订单列表
    queryList: (data) => axios.get({url: "/alpine/sale/warrantySetting/queryList", data:data}),
    // 保存
    save: (data) => axios.post({url: "/alpine/sale/warrantySetting/save", data:data}),
    // 删除
    delete: (id) => axios.del({url: "/alpine/sale/warrantySetting/delete", data: {id}}),

}